import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Line } from "recharts";
import { MONTHS_ES } from "../constants";

export const WinRateEvolution = ({ winRateData }) => {
  if (!winRateData || !winRateData.evolution || winRateData.evolution.length === 0) return null;

  const formatMonth = (monthStr) => {
    const [year, month] = monthStr.split('-');
    return `${MONTHS_ES[parseInt(month) - 1]} ${year.slice(2)}`;
  };

  return (
    <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white">Evolución del Win Rate Mensual</h3>
        <div className="flex items-center gap-6 text-sm">
          <div>
            <span className="text-gray-400">Promedio: </span>
            <span className="text-white font-medium">{winRateData.average_win_rate}%</span>
          </div>
          {winRateData.best_win_rate_month && (
            <div>
              <span className="text-gray-400">Mejor: </span>
              <span className="text-emerald-400 font-medium">{formatMonth(winRateData.best_win_rate_month.month)} ({winRateData.best_win_rate_month.win_rate}%)</span>
            </div>
          )}
          {winRateData.worst_win_rate_month && (
            <div>
              <span className="text-gray-400">Peor: </span>
              <span className="text-red-400 font-medium">{formatMonth(winRateData.worst_win_rate_month.month)} ({winRateData.worst_win_rate_month.win_rate}%)</span>
            </div>
          )}
        </div>
      </div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={winRateData.evolution}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f1f23" />
            <XAxis dataKey="month" stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} tickFormatter={formatMonth} />
            <YAxis stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
            <Tooltip content={({ active, payload, label }) => {
              if (active && payload && payload.length) {
                return (
                  <div className="bg-gray-900 border border-gray-700 rounded-lg p-3 shadow-xl">
                    <p className="text-gray-400 text-sm mb-1">{formatMonth(label)}</p>
                    <p className="text-purple-400 font-semibold">Win Rate: {payload[0].value}%</p>
                    <p className="text-gray-400 text-sm">Trades: {payload[0].payload.trades}</p>
                    <p className="text-gray-400 text-sm">Wins: {payload[0].payload.wins}</p>
                  </div>
                );
              }
              return null;
            }} />
            <Line type="monotone" dataKey="win_rate" name="Win Rate" stroke="#a855f7" strokeWidth={3} dot={{ fill: '#a855f7', strokeWidth: 2, r: 4 }} activeDot={{ r: 6, fill: '#a855f7' }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
